/**
 * Valid values for D6 content types
 * @module services/content/d6-content-types
 */
import { Map, OrderedSet } from 'immutable'
import {
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_ARTICLE,
  CONTENT_TYPE_PERSON,
  CONTENT_TYPE_TAG,
  CONTENT_TYPE_GUIDE,
  CONTENT_TYPE_GUIDE_DAY,
  CONTENT_TYPE_PROMOTION,
  CONTENT_TYPE_FAQ,
  CONTENT_TYPE_PRODUCT,
  CONTENT_TYPE_BONUS_PACKAGE,
  CONTENT_TYPE_SERVICE,
  CONTENT_TYPE_COURSE,
  CONTENT_TYPE_COURSE_MODULE,
  YI_CONTENT_TYPE_YI_COURSE,
  YI_CONTENT_TYPE_YI_SERIES,
  YI_CONTENT_TYPE_YI_COURSE_SALES_PAGE,
  YI_CONTENT_TYPE_YI_COURSE_MODULE_GROUP,
  YI_CONTENT_TYPE_YI_COURSE_MODULE,
  YI_CONTENT_TYPE_YI_MEMBERSHIP_PROMO,
  YI_CONTENT_TYPE_YI_HOMEPAGE_HERO_CONTENT,
} from './content-types'

/**
 * The Drupal 6 node content type which should be
 * used for non tag and people content
 */
export const D6_CONTENT_TYPE_NODE = 'node'

/**
 * The Drupal 6 term content type which should be
 * used for tag and people content
 */
export const D6_CONTENT_TYPE_TERM = 'term'

const D6_TYPE_MAPPING = Map({
  [CONTENT_TYPE_SERIES]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_VIDEO]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_ARTICLE]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_PERSON]: D6_CONTENT_TYPE_TERM,
  [CONTENT_TYPE_TAG]: D6_CONTENT_TYPE_TERM,
  [CONTENT_TYPE_GUIDE]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_GUIDE_DAY]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_PROMOTION]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_FAQ]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_PRODUCT]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_BONUS_PACKAGE]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_SERVICE]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_COURSE]: D6_CONTENT_TYPE_NODE,
  [CONTENT_TYPE_COURSE_MODULE]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_COURSE]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_SERIES]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_COURSE_SALES_PAGE]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_COURSE_MODULE]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_COURSE_MODULE_GROUP]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_MEMBERSHIP_PROMO]: D6_CONTENT_TYPE_NODE,
  [YI_CONTENT_TYPE_YI_HOMEPAGE_HERO_CONTENT]: D6_CONTENT_TYPE_NODE,
})

/**
 * Content types that were considered a term in d6
 */
const TERM_CONTENT_TYPES = OrderedSet([CONTENT_TYPE_PERSON, CONTENT_TYPE_TAG])

/**
 * Returns true when content type is a term match
 * @param {String} contentType The content type
 * @returns {Boolean} True when content type is a term match
 */
export function isTermContentType (contentType) {
  return TERM_CONTENT_TYPES.includes(contentType)
}

/**
 * Get the d6 content type give a content type
 * @param {String} contentType The content type
 * @returns {String} The d6 content type if found
 */
export function getD6ContentType (contentType) {
  return D6_TYPE_MAPPING.get(contentType)
}
/**
 * Get the content types given a d6 content type
 * @param {String} d6ContentType The d6 content type
 * @returns {import('immutable').Collection}
 */
export function getContentTypes (d6ContentType) {
  return D6_TYPE_MAPPING.filter((v) => v === d6ContentType)
    .keySeq()
    .sort()
}
